import { TextField, TextAreaField } from "@/components/form";
import { StepHeading, SubHeading } from "@/features/onboarding/components/wizard";
import { useT } from "@/features/onboarding/i18n";
import { type StepProps } from "./schema";

export function BusinessStep({ form }: StepProps) {
  const t = useT();
  const c = form.control;
  return (
    <div>
      <StepHeading title={t("biz.title")} subtitle={t("biz.subtitle")} />

      <SubHeading>{t("biz.estimates")}</SubHeading>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <TextField control={c} name="averageMonthlyVolume" label={t("biz.monthly")} type="number" inputMode="numeric" min={0} />
        <TextField control={c} name="averageTransactionAmount" label={t("biz.avgTicket")} type="number" inputMode="numeric" min={0} />
        <TextField control={c} name="maxTransactionAmount" label={t("biz.maxTicket")} type="number" inputMode="numeric" min={0} />
        <TextAreaField control={c} name="productDescription" label={t("biz.product")} placeholder={t("biz.productPlaceholder")} className="sm:col-span-2" />
      </div>
    </div>
  );
}
